export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-03.jpg'),
        title: '应用外包',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: `客户遗留应用的核心技术`,
      description: `<p style="font-size:1.05rem">
      MaesInfo的软件开发服务包括应用程序开发和定制产品开发。我们的开发人员专注于最先进的技术，以及作为客户遗留应用核心的主要技术。在MaesInfo，我们专注于使用软件组件构建应用程序，从而降低客户的成本和开发时间。这与我们强大的管理和沟通流程相结合，使我们成为优秀的外包合作伙伴，帮助您实现您的特定目标
      </p><p>服务范围：Web应用程序开发、
移动应用开发、
桌面应用开发、
嵌入式软件开发、
关系数据库运用数据、
AJAX应用程序、
业务流程自动化应用</p>`
    },
    {
      title: '我们的优势',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-03.jpg')+`)"></span>
      <span class="list">
        <i></i>明确问题和解决方案</br>
        <i></i>已知成本和已知时间尺度</br>
        <i></i>我们再最新系统、技术和流程方面的专业技能</br>
        <i></i>无需额外的成本</br>
        <i></i>开发场所的灵活性</br>
        <i></i>更多时间专注于您的核心业务活动
      </span>`
    }
  ]
}
